export class CurriculumServiceInterface {
}
